export const _validateField = {
  EmailValidation,
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function EmailValidation(value) {
  const _value = emailRegex.test(value);
  return _value;
}
